import React from 'react';
import { PortalOrigin, Dropdown } from '../../../ui-kit';
import { linkToNewDutyTransaction } from '../../../../utils/dutyTransactions';
import { IconCalendarXmark, IconExchange } from '../../../ui-kit/icons';
import AvailabilityCodeIcon from '../../../general/AvailabilityCodeIcon';

const DutyTransactionItems = ({ membershipId, startTime, endTime, group }) => (
  <>
    <Dropdown.Item
      href={linkToNewDutyTransaction('absence_requests', membershipId, {
        start_time: startTime,
        end_time: endTime
      })}
      target="_blank"
    >
      <IconCalendarXmark /> {I18n.t('activerecord.models.schedule/exchanges/absence_request.one')} {group.name}
    </Dropdown.Item>
    <Dropdown.Item
      href={linkToNewDutyTransaction('duty_exchanges', membershipId, {
        start_time: startTime,
        end_time: endTime
      })}
      target="_blank"
    >
      <IconExchange /> {I18n.t('activerecord.models.schedule/exchanges/duty_exchange.one')} {group.name}
    </Dropdown.Item>
  </>
);

const AvailabilityCodeSubMenu = ({ availabilityCodes, applyAvailabilityCode }) => (
  <Dropdown.SubMenu title={I18n.t('activerecord.models.schedule/availability_code.one')}>
    <Dropdown.Item onClick={() => applyAvailabilityCode(null)} key={'none'}>
      <i>{I18n.t('none')}</i>
    </Dropdown.Item>
    <Dropdown.Divider />
    {availabilityCodes.map(code => (
      <Dropdown.Item onClick={() => applyAvailabilityCode(code)} key={code.id}>
        <AvailabilityCodeIcon code={code} /> {code.name}
      </Dropdown.Item>
    ))}
  </Dropdown.SubMenu>
);

const ContextMenu = ({ menuState, userMemberships, availabilityCodes, applyAvailabilityCode, selectedGroupId }) => {
  if (!menuState.show) return null;
  availabilityCodes = availabilityCodes.filter(
    code => code.applicable_to_groups.includes(selectedGroupId) && code.purposes.includes('scheduling')
  );

  const group = menuState.group;
  const membership = userMemberships.find(m => m.group_id === group.id);

  if (!membership) return null;
  if (!menuState.duty && availabilityCodes.length === 0) return null;

  return (
    <PortalOrigin>
      <Dropdown.ContextMenu
        x={menuState.x}
        y={menuState.y}
        show={menuState.show}
        className={'personal-calendar-context-menu'}
        id={'personal-calendar-context-menu'}
      >
        {!menuState.duty && availabilityCodes.length > 0 && (
          <Dropdown.Item>
            <AvailabilityCodeSubMenu
              availabilityCodes={availabilityCodes}
              applyAvailabilityCode={applyAvailabilityCode}
            />
          </Dropdown.Item>
        )}
        {menuState.duty && (
          <DutyTransactionItems
            membershipId={membership.id}
            group={group}
            startTime={menuState.startTime}
            endTime={menuState.endTime}
          />
        )}
      </Dropdown.ContextMenu>
    </PortalOrigin>
  );
};

export default ContextMenu;
